module.exports = __webpack_public_path__ + "static/img/3.82339a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/imgs/goods/xunlonggaoshou/3.jpg
// module id = 0l8W
// module chunks = 1